import React, { useState } from 'react';
import {
  Carousel,
  LargeHeader,
  Gutter,
  Grid,
  GridRow,
  GridColumn,
} from '@axiom/ui';
import type { SavedCandidate } from '@axiom/validation';

import { useCandidateProfilesData } from '../../hooks/useCandidateProfilesData';
import { useUserAccountData } from '../../hooks/useUserAccountData';
import { DiscoverTalentEndCard } from '../DiscoverTalentEndCard/DiscoverTalentEndCard';
import { ContactAxiomModal } from '../ContactAxiomModal/ContactAxiomModal';

import { SavedTalentCarouselCard } from './SavedTalentCarouselCard';
import { SavedTalentCarouselEmptyStateCard } from './SavedTalentCarouselEmptyStateCard';

export const SavedTalentCarousel = () => {
  const { account, user } = useUserAccountData();
  const { savedCandidates } = useCandidateProfilesData(account);
  const [inquiredCandidate, setInquiredCandidate] = useState<
    SavedCandidate['candidate'] | null
  >(null);

  const buildChildren = () => {
    const kids = savedCandidates.map(candidate => {
      return (
        <SavedTalentCarouselCard
          user={user}
          account={account}
          candidate={candidate}
          key={`${account.id}-${candidate.id}`}
          setInquiredCandidate={setInquiredCandidate}
        />
      );
    });
    kids.push(<DiscoverTalentEndCard key="saved-endCard" account={account} />);
    return kids;
  };

  return (
    <>
      <LargeHeader name="SAVED_TALENT_HEADER">
        Your Saved talent{' '}
        {savedCandidates.length > 0 ? `(${savedCandidates.length})` : ''}
      </LargeHeader>
      <Gutter bottom="24px" />
      {savedCandidates.length > 0 ? (
        <Carousel name="SAVED_TALENT_CAROUSEL">{buildChildren()}</Carousel>
      ) : (
        <Grid name="SAVED_TALENT_EMPTY_STATE" stackable>
          <GridRow stretched>
            <GridColumn largeScreenWidth={8} tabletWidth={12} mobileWidth={12}>
              <SavedTalentCarouselEmptyStateCard />
              <Gutter only="smallScreen" bottom="16px" />
            </GridColumn>
            <GridColumn largeScreenWidth={4} tabletWidth={12} mobileWidth={12}>
              <DiscoverTalentEndCard account={account} />
            </GridColumn>
          </GridRow>
        </Grid>
      )}
      {inquiredCandidate ? (
        <ContactAxiomModal
          candidate={inquiredCandidate}
          onClose={() => {
            setInquiredCandidate(null);
          }}
        />
      ) : null}
    </>
  );
};
